import styled from 'styled-components';
import media from 'styles/media';

export const DisplayCheckbox = styled.div`
  -webkit-appearance: none;
  background-color: white;
  border: ${props => props.theme.checkboxButtonPrimaryBorderGray};
  border-radius: 5px;
  padding: 10px;
  position: relative;
  margin: 0px 1.2em 0 0;
  cursor: pointer;
  font-weight: 300;
  align-self: flex-start;
  font-family: system-ui;
  display: ${props => props.theme.checkboxButtonPrimaryCheckboxDisplay};
  ${media.IE9 ? `
    float: left;
  ` : ''};
  ${props => (props.checked ? `
    background-color: ${props.theme.confirmColor};
    border: ${props.theme.checkboxButtonPrimaryBorderActive};
    :after {
      content: '\\2713';
      font-size: 20px;
      position: absolute;
      width: 20px;
      top: 0;
      left: 0;
      color: white;
    }
  ` : '')};
`;

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  opacity: 0;
  position: absolute;
`;
